export default "__VITE_ASSET__9ViVh2PX__"